"use strict";

var _Text, _Box;
import { Box, HorizontalAutoScroller, Stack, Text } from '@autoguru/overdrive';
import { HeadingSection } from '~/src/components/HeadingSection/HeadingSection';
import * as styles from '~/src/components/ServiceProvidersFeedback/ServiceProvidersFeedback.css';
import { ServiceProvidersFeedbackCarousel } from '~/src/components/ServiceProvidersFeedback/ServiceProvidersFeedbackCarousel';
import { heading, sectionTitle, slideDuration, subheading, testimonials } from '~/src/components/ServiceProvidersFeedback/testimonials';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceProvidersFeedback = ({
  isDesktop,
  size
}) => {
  return /*#__PURE__*/_jsx(Box, {
    className: styles.container,
    paddingY: "8",
    paddingX: isDesktop ? 'none' : '5',
    children: /*#__PURE__*/_jsx(Box, {
      style: {
        maxWidth: '1200px',
        margin: '0 auto'
      },
      children: /*#__PURE__*/_jsxs(Stack, {
        space: "4",
        children: [/*#__PURE__*/_jsx(HeadingSection, {
          title: sectionTitle,
          size: size,
          colour: "white"
        }), _Text || (_Text = /*#__PURE__*/_jsx(Text, {
          strong: true,
          as: "p",
          align: "center",
          colour: "white",
          children: heading
        })), _Box || (_Box = /*#__PURE__*/_jsx(Box, {
          paddingBottom: "7",
          children: /*#__PURE__*/_jsx(Text, {
            as: "p",
            align: "center",
            colour: "white",
            size: "3",
            children: subheading
          })
        })), /*#__PURE__*/_jsx(HorizontalAutoScroller, {
          noControls: true,
          durationSeconds: slideDuration,
          sliderProgressColour: "primary",
          space: "5",
          columnWidth: ['full', 'full', '1/2'],
          children: testimonials.map(item => /*#__PURE__*/_jsx(ServiceProvidersFeedbackCarousel, {
            isDesktop: isDesktop,
            item: item
          }, `${item.company}-${item.heading}`))
        })]
      })
    })
  });
};
export default ServiceProvidersFeedback;